import React from 'react'
import './PreviousComments'
import diceIcon from './images/TTE_Icon_About.png'
import 'bootstrap/dist/css/bootstrap.min.css';

function About() {
    return (
        <div className="PrevComments d-flex justify-content-lg-center container-fluid" >
            <div className='row container '>
                <div className='about'>
                <img src={diceIcon} class="rounded-circle diceIcon" style={{display:'inline'}} alt="dice"></img>
                    <div className='row what text-center '>
                        <h1>What is it?</h1>
                        <h5>TableTop Encyclopedia is a website made to review and give suggestions on board games. Whether you're a seasoned player or haven't played a single game in your life other than UNO, this is the place for you! See what I and what other users have to say about your favorite games. Or if you don't see a game you like in the list of games, feel free to send a message about a game you'd like reviewed and submit it through the Suggestions system. I'll probably add it after playing the game. (This site was coded and is currently being run by only one person so it might take some time to be updated!)</h5>
                    </div>
                    <div className='row how text-center '>
                        <h1>What's the History of it?</h1>
                        <h5>I know you're probably not that interested in this part too much but I'll tell you anyway since you're already reading it! This site was designed, developed, and written all by me, just an average joe who sometimes codes in their free time. Creating a website from scratch was one of my 2023 new year resolutions, and a lot of (figurative) blood sweat and (literal) tears went into the making of this site. All of that to say I appreciate you being here!</h5>

                    </div>
                    <div className='row best text-center '>
                        <h1>How do I tell everyone that my game is the best one?</h1>
                        <h5>Well I'm glad you asked! For  your 100% objective opinion to be added to a game, all you need to do is sign in through Google and comment your review at the bottom of the page for the game you want to talk about.</h5>
                    </div>
                    <div className='row contact text-center '>
                        <h1>I have X question that needs to be answered. Who do I contact?</h1>
                        <h5>Go ahead and contact me directly at tabletopencyclopediahelp@gmail.com</h5>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default About
